import React from 'react';
import {useSelector} from "react-redux";
import {setEditSupplier} from "../../../../../_reducers/DataPanel/Suppliers/supplierSlice";
import {Col, Row} from "react-bootstrap";
import Input from "../../../../common/Input";
import {setSaveEditSupplier} from "../../../../../_reducers/activitySlice";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";

const EditSupplierAccounting = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const saveEditSupplier = useSelector((state) => state.ACTIVITY.saveEditSupplier);
    const editSupplier = useSelector((state) => state.SUPPLIERS_DATA.editSupplier[tabKey]);

    const handleOnChange = (e, type, compName) => {
        if (!saveEditSupplier) dispatch(setSaveEditSupplier(true));
        if (type === "input") {
            if(compName === "accounting") {
                dispatch(setEditSupplier({...editSupplier, accounting: e.target.value}));
            } else if (compName === "bypassAccounting") {
                dispatch(setEditSupplier({...editSupplier, bypassAccounting: e.target.value}));
            }
        }
    }
    return (
        <React.Fragment>
            <Row>
                <Col md={4}>
                    <Input
                        name="accounting"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                        label="Πρόθεμα Κωδικού Λογαριασμού"
                        value={editSupplier.accounting}
                        onChange={(e) => handleOnChange(e, "input", "accounting")}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name="bypassAccounting"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης"
                        label="Κωδικός Λογαριασμού Παράκαμψης"
                        value={editSupplier.bypassAccounting}
                        onChange={(e) => handleOnChange(e, "input", "bypassAccounting")}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default EditSupplierAccounting;